import React from 'react';
import { useState, useEffect } from 'react';
import Main from './components/Main';

function App() {
const [currentStep, setCurrentStep] = useState([0])






  return (
    <div >
      <Main/>
    </div>
  );
}

export default App;
